import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { CMSPlaceholderModel } from '../../models/cms-placeholder.model';

// services
import API from '../../services/api';

// query keys
import cmsPlaceholderKeys from './_queryKeys';

const getPlaceholders = async (): Promise<{
    filterable: CMSPlaceholderModel[];
    messageable: CMSPlaceholderModel[];
}> => {
    const { data } = await API.fetchCMSPlaceholder();
    return {
        filterable: (data ?? []).filter(
            (item: CMSPlaceholderModel) => item.is_filterable,
        ),
        messageable: (data ?? []).filter(
            (item: CMSPlaceholderModel) => item.is_messageable,
        ),
    };
};

export default function useCMSPlaceholderQuery() {
    return useQuery<
        {
            filterable: CMSPlaceholderModel[];
            messageable: CMSPlaceholderModel[];
        },
        BaseError
    >({
        queryKey: cmsPlaceholderKeys.all,
        queryFn: () => getPlaceholders(),
        staleTime: 1000 * 24 * 60 * 60,
    });
}
